module.exports = __webpack_public_path__ + "static/media/group-close.aa30561b.png";